var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',[_c('ul',{staticClass:"footer-menu"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/admin'}}},[_vm._v("Yönetim Paneli")])],1)])]),_c('div',{staticClass:"copyright text-center"},[_vm._v("\n      © Powered by OCTO\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }